import { HTMLProps, ReactElement, cloneElement, forwardRef } from "react";
import { useTooltipLegacyContext } from "./useTooltipLegacyContext";
import styles from "./TooltipLegacy.module.scss";
import cx from "classnames";
import { useMergeRefs } from "../../hooks";

export type TooltipLegacyTriggerProps = HTMLProps<HTMLElement> & {
  children: ReactElement;
};
export const TooltipLegacyTrigger = forwardRef<
  HTMLElement,
  TooltipLegacyTriggerProps
>(function TooltipLegacyTrigger({ children, className, ...props }, propRef) {
  const context = useTooltipLegacyContext();
  const ref = useMergeRefs([context.refs.setReference, propRef]);
  const { "aria-describedby": ariaDescribedBy, ...restOfContextProps } =
    context.getReferenceProps(props);
  const child = cloneElement(children, {
    ref,
    "aria-describedby": ariaDescribedBy,
  });

  return (
    <span
      ref={ref}
      className={cx([styles["trigger-legacy"]], className)}
      data-anv="tooltip-trigger"
      // The user can style the trigger based on the state
      data-state={context.open ? "open" : "closed"}
      {...restOfContextProps}
    >
      {child}
    </span>
  );
});
